<template>
  <div id="app">
    <compornent></compornent>
  </div>
</template>

<script>
import compornent from "./components/compornent/_index";

export default {
  name: "App",
  components: {
    compornent
  }
};
</script>

<style>
#app {
}
</style>



// WEBPACK FOOTER //
// src/App.vue